// extracted by mini-css-extract-plugin
export var bodyRow = "_dq-d";
export var cardColumns = "_dq-e";
export var ellipsesOverflow = "_dq-2";
export var flatBottomCorners = "_dq-3";
export var flatTopCorners = "_dq-4";
export var headerActionsDropdown = "_dq-f";
export var headerBottomRow = "_dq-c";
export var headerTopRow = "_dq-b";
export var orderDetailsWrapper = "_dq-0";
export var orderInfoContainer = "_dq-1";
export var productDetails = "_dq-9";
export var productImage = "_dq-5";
export var responsiveTable = "_dq-8";
export var shipmentContainer = "_dq-a";
export var tableBottomLeft = "_dq-6";
export var tableBottomRight = "_dq-7";
export var trackingLink = "_dq-g";